export default __webpack_public_path__ + "static/sheet-039ec29444238fa8b855f5c97c0905f4.png";